import { render, staticRenderFns } from "./CreateElectricity.vue?vue&type=template&id=77072b57&scoped=true&"
import script from "./CreateElectricity.vue?vue&type=script&lang=js&"
export * from "./CreateElectricity.vue?vue&type=script&lang=js&"
import style0 from "./CreateElectricity.vue?vue&type=style&index=0&id=77072b57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77072b57",
  null
  
)

component.options.__file = "CreateElectricity.vue"
export default component.exports